export default __webpack_public_path__ + "static/6-a2bad59bfeffeb6d6b6c3895f99c556e.png";